import { render } from "./SurveyAnswer.vue?vue&type=template&id=466bc217&scoped=true"
import script from "./SurveyAnswer.vue?vue&type=script&lang=js"
export * from "./SurveyAnswer.vue?vue&type=script&lang=js"

import "./SurveyAnswer.vue?vue&type=style&index=0&id=466bc217&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466bc217"]])

export default __exports__